import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { printStickerConstants } from 'app/constants/csv/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { oilStickerSizes } from 'app/constants/oilStickerSizes';
import { DataService, DateService, HelperService, HTTPService } from 'app/services';
import { DOCUMENT } from '@angular/common';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { getLanguagePreferences } from 'app/constants/language-translate';

@Component({
  selector: 'app-oil-change-print-view',
  templateUrl: './oil-change-print-view.component.html',
  styleUrls: ['./oil-change-print-view.component.scss'],
})
export class OilChangePrintViewComponent implements OnInit {

  tireStorageInfos: any[] = [];
  vehicleData = { name: '', date: '', mileage: '', nextMileage: '', filterChange: '', measuringUnit: '' };
  oilSticker: any = {};
  printOilStickerSettings = {
    stickerClass: { value: '' },
    companyName: '',
    companyPhone: '',
    stickerHeaderLogo: '',
    headerType: '',
    customStickerSize: '',
    defaultStickerSize: '',
  };
  printSample = {
    printSample: null,
    stickerClass: '',
    logo: null,
    printRO: false,
    isOilStickerImproved: false,
  };
  isLoading = false;
  isChecking: boolean = true;
  newDate = this.dateService.formatDate(new Date(), datetimeFormat.mmmdyyyy);
  isOilStickerImproved: boolean = false;
  dataServiceSubscription: Subscription;
  currentLang: string = 'en';
  constructor(private activatedRoute: ActivatedRoute, public dataService: DataService, public helperService: HelperService, public httpService: HTTPService, public dateService: DateService, @Inject(DOCUMENT) private _document: HTMLDocument, private translate: TranslateService) { }

  ngOnInit() {
    let printContent: HTMLElement;
    printContent = this._document.getElementById('ro-oil-sticker')
    this.getPrintView(printContent)
    this.vehicleData.name = this.activatedRoute.snapshot.queryParamMap.get('name');
    this.currentLang = this.activatedRoute.snapshot.queryParamMap.get('lang');
    this.translate.use(this.currentLang);
    this.vehicleData.mileage = this.activatedRoute.snapshot.queryParamMap.get('mileage');
    this.vehicleData.nextMileage = this.activatedRoute.snapshot.queryParamMap.get('nextMileage');
    this.vehicleData.filterChange = this.activatedRoute.snapshot.queryParamMap.get('filterChange');
    if (this.currentLang === 'fr') {
      const date = this.activatedRoute.snapshot.queryParamMap.get('date');
      this.vehicleData.date = date.replace('.', '');
    } else {
      this.vehicleData.date = this.activatedRoute.snapshot.queryParamMap.get('date');
    }
    this.vehicleData.measuringUnit = this.activatedRoute.snapshot.queryParamMap.get('measuringUnit');
    const printSample = this.activatedRoute.snapshot.queryParamMap.get('printSample');
    if (printSample) {
      this.printSample = JSON.parse(printSample);
    }
    this.isOilStickerImproved = this.printSample.isOilStickerImproved;
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }
  }

  getPrintView(printContent) {
    let payload = [
      'printOilStickerSettings.companyName',
      'printOilStickerSettings.companyPhone',
      'printOilStickerSettings.stickerHeaderLogo',
      'printOilStickerSettings.defaultStickerSize',
      'printOilStickerSettings.customStickerSize',
      'printOilStickerSettings.headerType',
    ];
    this.httpService
      .getUpdateLocationSettings(payload)
      .then((response: any) => {
        if (response.appsettings && response.appsettings.printOilStickerSettings) {
          this.printOilStickerSettings = response.appsettings && response.appsettings.printOilStickerSettings;
          if (response.logo && this.getDefaultSticker()) {
            if (response.logo) {
              this.printSample.logo = response.logo;
            }
          }
          if (!this.printSample.stickerClass) {
            if (this.getDefaultSticker()) {
              this.printOilStickerSettings.stickerClass = oilStickerSizes.filter((size) => size.label === this.printOilStickerSettings.defaultStickerSize)[0];
            } else {
              this.printOilStickerSettings.stickerClass = oilStickerSizes.filter((size) => size.label === this.printOilStickerSettings.customStickerSize)[0];
            }
          } else {
            this.printOilStickerSettings.stickerClass = oilStickerSizes.filter((size) => size.label === this.printSample.stickerClass)[0];
          }

          if (!this.printSample.printSample) {
            if (!this.getDefaultSticker() && this.printOilStickerSettings.stickerHeaderLogo) {
              this.printSample.logo = this.printOilStickerSettings.stickerHeaderLogo;
            }
          }
        } else {
          if (this.printSample.stickerClass) {
            this.printOilStickerSettings.stickerClass = oilStickerSizes.filter((size) => size.label === this.printSample.stickerClass)[0];

            const defaultData = this.helperService.getCompany();
            if (defaultData) {
              this.printOilStickerSettings.companyName = defaultData.companyName;
              this.printOilStickerSettings.companyPhone = this.helperService.removePhoneFormatting(defaultData.companyPhone);
            }

            if (response.logo && this.getDefaultSticker()) {
              this.printSample.logo = response.logo;
            }
          } else {
            this.printOilStickerSettings.stickerClass.value = oilStickerSizes[oilStickerSizes.length - 1].value;
          }
        }
        let url = `ro-oil-sticker`;
        setTimeout(() => {
          this.helperService.openPrintPageInNewTab(url, printContent);
        }, 1000);
      })
      .catch((err) => this.helperService.showToaster('error', err))
      .finally(() => (this.isLoading = true));
  }

  getDefaultSticker() {
    if (this.printSample.printSample === true) {
      return true;
    } else if (this.printSample.printSample === false) {
      return false;
    } else if (this.printOilStickerSettings.headerType === printStickerConstants.default) {
      return true;
    } else {
      return false;
    }
  }
}
